module.exports = __webpack_public_path__ + "img/empty.ed18ba71.png";